// @ts-nocheck
/* ══════════════════════════════════════════════════════
   REYNA Product Detail Page — Interactive JS
   - Variant option picking (color + size)
   - Price + availability updates
   - Accordion toggle
   - Size guide modal
   - Image lightbox (zoom)
   - Add to Bag (AJAX cart)
   - Buy it now (direct checkout with selected variant)
   - Wishlist toggle (localStorage)
   - Share (WhatsApp + copy link)
   - Toast notification
   ══════════════════════════════════════════════════════ */

(function () {
  'use strict';

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  // Shared reference so initSizeConverter can trigger a variant update
  // after syncing the product-page size button from inside the guide.
  // Set by initVariantPicker at init time; called by initSizeConverter.
  let _variantUpdate = null;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function showToast(msg) {
    const toast = $('[data-toast]');
    if (!toast) return;
    const m = toast.querySelector('[data-toast-msg]');
    if (m) m.textContent = msg;
    toast.classList.add('show');
    clearTimeout(toast._t);
    toast._t = setTimeout(() => toast.classList.remove('show'), 2400);
  }

  function formatMoney(cents) {
    if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents);
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
    try {
      return new Intl.NumberFormat('en-IN', { style: 'currency', currency, minimumFractionDigits: 0 }).format(cents / 100);
    } catch (e) {
      return '₹' + (cents / 100).toFixed(0);
    }
  }

  /* ── Accordion ── */
  function initAccordion() {
    $$('.acc__trig').forEach((trig) => {
      trig.addEventListener('click', () => {
        const body = trig.nextElementSibling;
        const open = trig.classList.toggle('open');
        trig.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (body) body.classList.toggle('open', open);
      });
    });
  }

  /* ── Size guide modal ── */
  function initSizeGuide() {
    const ov = $('[data-size-guide]');
    if (!ov) return;
    $$('[data-size-guide-open]').forEach((b) => {
      b.addEventListener('click', (e) => {
        e.preventDefault();
        ov.classList.add('open');
        ov.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
    });
    const close = () => {
      ov.classList.remove('open');
      ov.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };
    $$('[data-size-guide-close]').forEach((b) => b.addEventListener('click', close));
    ov.addEventListener('click', (e) => { if (e.target === ov) close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && ov.classList.contains('open')) close(); });
  }

  /* ── Lightbox ── */
  function initLightbox() {
    const lb = $('[data-lightbox]');
    if (!lb) return;
    const lbImg = lb.querySelector('[data-lightbox-img]');
    const open = (src, alt) => {
      if (!src) return;
      lbImg.src = src;
      lbImg.alt = alt || '';
      lb.classList.add('open');
      lb.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    };
    const close = () => {
      lb.classList.remove('open');
      lb.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };
    $$('.pdp__gallery-item--photo').forEach((item) => {
      // Track the pointer so a horizontal swipe in the mobile carousel
      // doesn't get treated as a tap and pop the lightbox open.
      let downX = 0;
      let downY = 0;
      let moved = false;
      item.addEventListener('pointerdown', (e) => {
        downX = e.clientX;
        downY = e.clientY;
        moved = false;
      }, { passive: true });
      item.addEventListener('pointerup', (e) => {
        moved = Math.abs(e.clientX - downX) > 10 || Math.abs(e.clientY - downY) > 10;
      }, { passive: true });
      item.addEventListener('click', () => {
        if (moved) { moved = false; return; }
        const src = item.dataset.zoomSrc || (item.querySelector('img') && item.querySelector('img').src);
        const alt = item.querySelector('img') && item.querySelector('img').alt;
        open(src, alt);
      });
    });
    $$('[data-lightbox-close]').forEach((b) => b.addEventListener('click', close));
    lb.addEventListener('click', (e) => { if (e.target === lb) close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && lb.classList.contains('open')) close(); });
  }

  /* ── Variant picker ── */
  function initVariantPicker() {
    const pdp = $('.pdp');
    if (!pdp) return;
    const form = pdp.querySelector('.pdp__form');
    if (!form) return;
    const variantsScript = pdp.querySelector('script[data-product-variants]');
    if (!variantsScript) return;
    let variants = [];
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) { return; }

    const variantInput = form.querySelector('[data-variant-id]');
    const priceEl = pdp.querySelector('[data-pdp-price]');
    const compareEl = pdp.querySelector('[data-pdp-compare]');
    const atbBtn = form.querySelector('[data-atb]');
    const atbText = form.querySelector('[data-atb-text]');
    const buynow = pdp.querySelector('[data-buynow]');

    function getSelectedOptions() {
      // Use option position (from data-option-position, 1-based) as key so that
      // hidden/skipped options (e.g. Material) don't break the index alignment.
      const map = {};
      $$('.pdp__option', pdp).forEach((opt) => {
        const active = opt.querySelector('.cswatch.active, .sbtn.active');
        if (active && active.dataset.optionPosition) {
          const idx = parseInt(active.dataset.optionPosition, 10) - 1; // 0-based
          map[idx] = active.dataset.optionValue;
        }
      });
      return map;
    }

    function findMatchingVariant(map) {
      return variants.find((v) =>
        Object.entries(map).every(([idx, val]) => v.options[Number(idx)] === val)
      );
    }

    function updateLabels() {
      $$('.pdp__option', pdp).forEach((opt) => {
        const active = opt.querySelector('.cswatch.active, .sbtn.active');
        const label = opt.querySelector('[data-option-label]');
        if (label && active) label.textContent = active.dataset.optionValue || active.textContent.trim();
      });
    }

    function update() {
      const map = getSelectedOptions();
      const variant = findMatchingVariant(map);
      updateLabels();
      if (!variant) {
        if (atbText) atbText.textContent = 'Unavailable';
        if (atbBtn) atbBtn.disabled = true;
        return;
      }
      if (variantInput) variantInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (atbBtn) atbBtn.disabled = !variant.available;
      if (atbText) atbText.textContent = variant.available ? 'Add to Bag' : 'Sold Out';
      if (buynow) {
        const url = new URL(window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root + 'cart/' + variant.id + ':1' : '/cart/' + variant.id + ':1', window.location.origin);
        buynow.href = url.pathname + '?checkout=true';
      }
      // Update URL
      try {
        const u = new URL(window.location.href);
        u.searchParams.set('variant', variant.id);
        history.replaceState({}, '', u.toString());
      } catch (e) { /* noop */ }
    }

    // Expose update() so initSizeConverter can call it after syncing the
    // active .sbtn from inside the guide (guide → product direction).
    _variantUpdate = update;

    // Click handlers
    $$('.cswatch, .sbtn', pdp).forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        if (btn.classList.contains('soldout')) return;
        const pos = btn.dataset.optionPosition;
        const parent = btn.parentElement;
        parent.querySelectorAll('.cswatch, .sbtn').forEach((b) => b.classList.remove('active'));
        btn.classList.add('active');
        update();
      });
    });

    // Initial
    update();
  }

  /* ── Add to cart (AJAX) ── */
  function initAddToCart() {
    const form = $('.pdp__form');
    if (!form) return;
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const atbBtn = form.querySelector('[data-atb]');
      const atbText = form.querySelector('[data-atb-text]');
      const originalText = atbText ? atbText.textContent : '';
      if (atbBtn) atbBtn.disabled = true;
      if (atbText) atbText.textContent = 'Adding…';
      try {
        const fd = new FormData(form);
        const res = await fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd,
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Unable to add');
        atbBtn.classList.add('added');
        if (atbText) atbText.textContent = 'Added ✓';
        showToast('Added to bag');
        // Refresh cart icon count if present
        try {
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          document.querySelectorAll('[data-cart-count], .acts-icons__count').forEach((el) => {
            el.textContent = cart.item_count;
          });
          document.dispatchEvent(new CustomEvent('reyna:cart-updated', { detail: cart }));
          // Open the cart-drawer-component and trigger cart-items-component to re-render.
          // `data.itemCount` is read by cart-icon-component to update the bubble count.
          // `data.sections` being absent triggers sectionRenderer.renderSection in cart-items-component.
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: cart, data: { itemCount: cart.item_count, source: 'reyna-add-to-cart' } },
          }));
        } catch (err) { /* noop */ }
        setTimeout(() => {
          atbBtn.classList.remove('added');
          if (atbText) atbText.textContent = originalText || 'Add to Bag';
          atbBtn.disabled = false;
        }, 2000);
      } catch (err) {
        showToast((err && err.message) || 'Could not add to bag');
        if (atbText) atbText.textContent = originalText || 'Add to Bag';
        if (atbBtn) atbBtn.disabled = false;
      }
    });
  }

  /* ── Buy it now ── */
  function initBuyNow() {
    const buynow = $('[data-buynow]');
    if (!buynow) return;
    buynow.addEventListener('click', (e) => {
      e.preventDefault();
      const form = $('.pdp__form');
      if (!form) return;
      const variantInput = form.querySelector('[data-variant-id]');
      if (!variantInput || !variantInput.value) {
        showToast('Please select options');
        return;
      }
      // Submit the form to /cart/add then redirect to checkout
      const fd = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd,
      }).then(() => {
        window.location.href = '/checkout';
      }).catch(() => { window.location.href = '/checkout'; });
    });
  }

  /* ── Wishlist (localStorage) ── */
  function initWishlist() {
    const btn = $('[data-wishlist]');
    if (!btn) return;
    const pdp = $('.pdp');
    const pid = pdp && pdp.dataset.productId;
    if (!pid) return;
    const KEY = 'reyna_wishlist';
    const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } };
    const write = (arr) => { try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch (e) {} };
    // Outline heart when unsaved, solid when saved.
    const icon = btn.querySelector('i');
    const paint = (on) => {
      btn.classList.toggle('saved', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (!icon) return;
      icon.classList.toggle('fa-solid', on);
      icon.classList.toggle('fa-regular', !on);
    };

    paint(read().includes(pid));

    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const cur = read();
      const idx = cur.indexOf(pid);
      if (idx >= 0) { cur.splice(idx, 1); paint(false); showToast('Removed from wishlist'); }
      else { cur.push(pid); paint(true); showToast('Saved to wishlist'); }
      write(cur);
    });
  }

  /* ── Share ── */
  function initShare() {
    $$('[data-share]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const kind = btn.dataset.share;
        const url = window.location.href;
        const title = document.title;
        if (kind === 'whatsapp') {
          window.open('https://wa.me/?text=' + encodeURIComponent(title + ' — ' + url), '_blank', 'noopener');
        } else if (kind === 'instagram') {
          // Instagram has no direct web share URL; use Web Share API on mobile
          // (device will offer Instagram), otherwise copy link
          if (navigator.share) {
            navigator.share({ title: title, url: url }).catch(() => {});
          } else if (navigator.clipboard) {
            navigator.clipboard.writeText(url).then(() => showToast('Link copied — paste on Instagram'));
          } else {
            showToast('Copy the page link and share on Instagram');
          }
        } else if (kind === 'copy') {
          if (navigator.clipboard) {
            navigator.clipboard.writeText(url).then(() => showToast('Link copied'));
          } else {
            const ta = document.createElement('textarea');
            ta.value = url;
            document.body.appendChild(ta);
            ta.select();
            try { document.execCommand('copy'); showToast('Link copied'); } catch (err) {}
            document.body.removeChild(ta);
          }
        }
      });
    });
  }

  /* ── Recommendations Swiper ──
     Items per breakpoint come from the section settings via data attributes,
     so the Customizer drives the layout instead of hardcoded values. */
  function initRecsSwiper() {
    const el = document.querySelector('.recs__swiper');
    if (!el || !window.Swiper) return;
    // Destroy existing instance if any
    if (el.swiper) el.swiper.destroy(true, true);

    const host = el.closest('[data-recs]');
    const read = (key, fallback) => {
      const n = parseFloat(host && host.dataset[key]);
      return isNaN(n) ? fallback : n;
    };
    // A fractional slidesPerView is what reveals the edge of the next card.
    const peek = host && host.dataset.peek === 'true' ? 0.2 : 0;

    new Swiper(el, {
      slidesPerView: read('itemsMobile', 1) + peek,
      spaceBetween: read('space', 1),
      grabCursor: true,
      loop: host ? host.dataset.loop === 'true' : false,
      navigation: {
        prevEl: '.recs__arr--prev',
        nextEl: '.recs__arr--next'
      },
      breakpoints: {
        560: { slidesPerView: read('itemsTablet', 2) + peek },
        1024: { slidesPerView: read('itemsDesktop', 4) + peek }
      }
    });
  }

  /* ── Product Recommendations (AJAX section render) ── */
  function initRecommendations() {
    const container = $('[data-recs]');
    if (!container) return;
    // A hand-picked collection is already rendered server-side — re-fetching
    // the recommendations endpoint would only overwrite it with related products.
    if (container.dataset.recsSource !== 'related') return;
    const url = container.dataset.url;
    if (!url) return;

    const track = container.querySelector('.swiper-wrapper');
    if (!track) return;

    fetch(url)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fetched = doc.querySelector('[data-recs] .swiper-wrapper');
        if (!fetched || !fetched.children.length) return;

        // Shopify often returns only one or two related products on a small
        // catalogue. Merge rather than replace, so the row never shrinks below
        // what the server already rendered: recommendations first, then the
        // existing fallback cards, deduped by product URL and capped at the
        // section's limit.
        const limit = parseInt(container.dataset.limit, 10) || 0;
        const seen = new Set();
        const merged = [];

        const collect = (slide) => {
          const link = slide.querySelector('a[href]');
          const href = link && link.getAttribute('href');
          if (!href || seen.has(href)) return;
          seen.add(href);
          merged.push(slide);
        };

        Array.from(fetched.children).forEach(collect);
        Array.from(track.children).forEach(collect);
        if (!merged.length) return;

        // Tear the slider down before touching its slides, or Swiper's own
        // duplicate/positioning state is left pointing at removed nodes.
        const swiperEl = container.querySelector('.recs__swiper');
        if (swiperEl && swiperEl.swiper) swiperEl.swiper.destroy(true, true);

        const keep = limit > 0 ? merged.slice(0, limit) : merged;
        track.replaceChildren.apply(track, keep);

        initRecsSwiper();
      })
      .catch(() => {/* noop — fallback already shown */});
  }

  /* ── Size converter ──
     Reads whichever size table is in the modal and builds a two-step picker:
     choose the system you know, then your value. Every other system fills in
     automatically and the matching table row is highlighted.

     Two-way sync:
     - Product → guide: clicking a .sbtn on the page pre-selects the guide chip.
     - Guide → product: clicking a guide chip (.sg-conv__val) or a table row
       activates the matching .sbtn on the product page and fires a variant update.

     Loop prevention: _fromGuide flag stops the .sbtn click listener (which
     normally syncs product→guide) from re-firing when the guide drives the
     selection, preventing a redundant re-render. */
  function initSizeConverter() {
    const ov = $('[data-size-guide]');
    if (!ov) return;

    const host = ov.querySelector('[data-size-converter]');
    if (!host) return;

    const table = ov.querySelector('table');
    if (!table) return;

    // Prefer a real thead; fall back to the first body row (metafield tables
    // often have no thead).
    let headCells = $$('thead th, thead td', table);
    let bodyRows = $$('tbody tr', table);
    if (!headCells.length) {
      const all = $$('tr', table);
      if (all.length < 2) return;
      headCells = $$('th, td', all[0]);
      bodyRows = all.slice(1);
    }

    const systems = headCells.map((c) => c.textContent.trim()).filter(Boolean);
    if (systems.length < 2) return;

    // Only rows whose cell count matches the header are usable.
    const rows = bodyRows
      .map((tr) => ({ tr, cells: $$('th, td', tr).map((c) => c.textContent.trim()) }))
      .filter((r) => r.cells.length === systems.length);
    if (!rows.length) return;

    let sysIndex = 0;
    let rowIndex = -1;

    // True while the guide is driving a product-page update; prevents the
    // .sbtn click listener at the bottom from re-processing the same change.
    let _fromGuide = false;

    // Returns true when every product-page .sbtn that matches any cell value
    // in `cells` carries the .soldout class (meaning no available variant for
    // this row). Returns false when no .sbtn matches — the size may not be a
    // product option, so we don't know and assume available.
    const isSizeSoldout = (cells) => {
      const matches = $$('.size-opts .sbtn').filter((btn) => {
        const v = btn.dataset.optionValue || btn.textContent.trim();
        return cells.some((c) => c === v);
      });
      if (!matches.length) return false;
      return matches.every((btn) => btn.classList.contains('soldout'));
    };

    // Activates the matching non-soldout .sbtn on the product page and triggers
    // a variant update so price/ATB/URL reflect the new selection.
    // `cells` is the full array of cell values for the selected table row so we
    // can match against whichever column the product options use.
    const syncSizeToProduct = (cells) => {
      const pdp = $('.pdp');
      if (!pdp) return;
      let matched = null;
      $$('.size-opts .sbtn', pdp).forEach((btn) => {
        if (btn.classList.contains('soldout')) return;
        const v = btn.dataset.optionValue || btn.textContent.trim();
        if (!matched && cells.some((c) => c === v)) matched = btn;
      });
      if (!matched) return;

      _fromGuide = true;
      const parent = matched.parentElement;
      parent.querySelectorAll('.sbtn').forEach((b) => b.classList.remove('active'));
      matched.classList.add('active');
      // _variantUpdate is set by initVariantPicker; safe to call because
      // initVariantPicker runs after initSizeConverter in the ready() block,
      // but click handlers fire long after all init has completed.
      if (_variantUpdate) _variantUpdate();
      _fromGuide = false;
    };

    host.hidden = false;
    host.innerHTML =
      '<div class="sg-conv__title">Find your size</div>' +
      '<div class="sg-conv__step"><span class="sg-conv__label">I know my size in</span>' +
      '<div class="sg-conv__chips" data-conv-systems></div></div>' +
      '<div class="sg-conv__step"><span class="sg-conv__label">My size is</span>' +
      '<div class="sg-conv__chips" data-conv-values></div></div>' +
      '<div class="sg-conv__result" data-conv-result hidden></div>';

    const sysWrap = host.querySelector('[data-conv-systems]');
    const valWrap = host.querySelector('[data-conv-values]');
    const resWrap = host.querySelector('[data-conv-result]');

    const chip = (text, cls) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = cls;
      b.textContent = text;
      return b;
    };

    const clearMatch = () => {
      rows.forEach((r) => r.tr.classList.remove('is-match'));
    };

    const renderResult = () => {
      if (rowIndex < 0) {
        resWrap.hidden = true;
        resWrap.innerHTML = '';
        clearMatch();
        return;
      }
      const cells = rows[rowIndex].cells;
      resWrap.hidden = false;
      resWrap.innerHTML = systems
        .map(
          (s, i) =>
            '<div class="sg-conv__cell' +
            (i === sysIndex ? ' is-source' : '') +
            '"><span class="sg-conv__cell-lbl"></span>' +
            '<span class="sg-conv__cell-val"></span></div>'
        )
        .join('');
      $$('.sg-conv__cell', resWrap).forEach((cell, i) => {
        cell.querySelector('.sg-conv__cell-lbl').textContent = systems[i];
        cell.querySelector('.sg-conv__cell-val').textContent = cells[i] || '—';
      });

      clearMatch();
      rows[rowIndex].tr.classList.add('is-match');
    };

    const renderValues = () => {
      valWrap.innerHTML = '';
      rows.forEach((r, i) => {
        const value = r.cells[sysIndex];
        if (!value) return;
        const soldout = isSizeSoldout(r.cells);
        const cls =
          'sg-conv__val' +
          (i === rowIndex ? ' is-active' : '') +
          (soldout ? ' soldout' : '');
        const b = chip(value, cls);
        if (soldout) {
          // Mirror the product-page .sbtn behaviour: disabled but visible.
          b.disabled = true;
          b.setAttribute('aria-disabled', 'true');
        } else {
          b.addEventListener('click', () => {
            rowIndex = i;
            renderValues();
            renderResult();
            // Guide → product sync
            syncSizeToProduct(r.cells);
          });
        }
        valWrap.appendChild(b);
      });
    };

    const renderSystems = () => {
      sysWrap.innerHTML = '';
      systems.forEach((s, i) => {
        const b = chip(s, 'sg-conv__sys' + (i === sysIndex ? ' is-active' : ''));
        b.addEventListener('click', () => {
          if (sysIndex === i) return;
          sysIndex = i;
          renderSystems();
          renderValues();
          renderResult();
        });
        sysWrap.appendChild(b);
      });
    };

    // If the customer already picked a size on the page, preselect that row.
    const chosen = $('.size-opts .sbtn.active');
    if (chosen) {
      const label = chosen.textContent.trim();
      for (let c = 0; c < systems.length && rowIndex < 0; c++) {
        const hit = rows.findIndex((r) => r.cells[c] === label);
        if (hit > -1) {
          sysIndex = c;
          rowIndex = hit;
        }
      }
    }

    renderSystems();
    renderValues();
    renderResult();

    // Make every table row directly clickable — same as clicking the
    // corresponding chip. Soldout rows are skipped.
    rows.forEach((r, i) => {
      r.tr.style.cursor = 'pointer';
      r.tr.addEventListener('click', () => {
        if (isSizeSoldout(r.cells)) return;
        rowIndex = i;
        renderValues();
        renderResult();
        syncSizeToProduct(r.cells);
      });
    });

    // Product → guide: keep the converter in step with size buttons on the page.
    // Skip when the guide itself is driving the selection (_fromGuide flag) to
    // avoid a redundant re-render loop.
    $$('.size-opts .sbtn').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (_fromGuide) return;
        const label = btn.textContent.trim();
        const hit = rows.findIndex((r) => r.cells[sysIndex] === label);
        if (hit > -1) {
          rowIndex = hit;
          renderValues();
          renderResult();
        }
      });
    });
  }

  /* ── Product gallery controls — mobile and desktop ──
     One controller for both breakpoints. The track is a horizontal
     scroll-snap carousel in swipe/slider mode and a plain stack or grid
     otherwise, so the active slide is read from whichever axis actually
     scrolls. Drives the counter, dots, thumbnails and arrows. */
  function initGallery() {
    const wrap = $('.pdp__gallery-wrap');
    if (!wrap) return;

    const gallery = wrap.querySelector('.pdp__gallery');
    if (!gallery) return;

    const items = $$('.pdp__gallery-item', gallery);
    if (items.length < 2) return;

    const counter = wrap.querySelector('[data-g-current]');
    const dots = $$('[data-g-dot]', wrap);
    const thumbs = $$('[data-g-thumb]', wrap);
    const prev = wrap.querySelector('[data-g-prev]');
    const next = wrap.querySelector('[data-g-next]');

    // Nothing to drive — don't attach scroll listeners.
    if (!counter && !dots.length && !thumbs.length && !prev && !next) return;

    let raf = 0;
    let lastIndex = -1;

    const isHorizontal = () => gallery.scrollWidth > gallery.clientWidth + 2;

    const activeIndex = () => {
      let best = 0;
      let bestDist = Infinity;

      if (isHorizontal()) {
        // Carousel: the slide nearest the centre of the track.
        const centre = gallery.scrollLeft + gallery.clientWidth / 2;
        items.forEach((el, i) => {
          const dist = Math.abs(el.offsetLeft + el.offsetWidth / 2 - centre);
          if (dist < bestDist) { bestDist = dist; best = i; }
        });
        return best;
      }

      // Stack or grid: the image nearest the middle of the viewport, so
      // thumbnails stay in step as the customer scrolls the page.
      const centre = window.innerHeight / 2;
      items.forEach((el, i) => {
        const r = el.getBoundingClientRect();
        const dist = Math.abs(r.top + r.height / 2 - centre);
        if (dist < bestDist) { bestDist = dist; best = i; }
      });
      return best;
    };

    const sync = () => {
      const i = activeIndex();
      if (i === lastIndex) return;
      lastIndex = i;

      if (counter) counter.textContent = String(i + 1);
      dots.forEach((d, di) => d.classList.toggle('is-active', di === i));
      thumbs.forEach((t, ti) => {
        const on = ti === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === items.length - 1;
    };

    const goTo = (i) => {
      const target = items[i];
      if (!target) return;
      if (isHorizontal()) {
        // scrollTo on the track only — scrollIntoView would also jump the page.
        gallery.scrollTo({
          left: target.offsetLeft - (gallery.clientWidth - target.offsetWidth) / 2,
          behavior: 'smooth',
        });
      } else {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    };

    dots.forEach((dot, i) => dot.addEventListener('click', () => goTo(i)));
    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => goTo(i)));
    if (prev) prev.addEventListener('click', () => goTo(Math.max(0, activeIndex() - 1)));
    if (next) next.addEventListener('click', () => goTo(Math.min(items.length - 1, activeIndex() + 1)));

    const schedule = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(sync);
    };

    gallery.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', () => { lastIndex = -1; schedule(); }, { passive: true });

    sync();
  }

  ready(() => {
    if (!$('.pdp')) return; // only run on PDP
    initAccordion();
    initSizeGuide();
    initSizeConverter();
    initLightbox();
    initGallery();
    initVariantPicker();
    initAddToCart();
    initBuyNow();
    initWishlist();
    initShare();
    initRecsSwiper();
    initRecommendations();
  });
})();
